export default "__VITE_ASSET__BFQ84KTJ__"